module.exports = {
    privacy: 'Privacidade',
    account: 'Conta',
    deleteAccount: 'Deletar conta',
    deleteMessage:
        'Para deletar sua conta, digite sua senha e clique em salvar.',
    password: 'Senha',
}
